const DashboardTabs = ({ tabs, activeTab, onSelect }) => (
  <div className="flex gap-1 border-b border-surface-container-high">
    {tabs.map((tab) => (
      <button
        key={tab}
        type="button"
        onClick={() => onSelect(tab)}
        className={`px-4 py-2 text-sm font-semibold rounded-t-lg transition-colors ${
          activeTab === tab
            ? "text-primary border-b-2 border-primary -mb-px"
            : "text-on-surface-variant hover:text-on-surface"
        }`}
      >
        {tab}
      </button>
    ))}
  </div>
);

export default DashboardTabs;
